export default "__VITE_ASSET__CnqamdRA__"